import styled from 'styled-components';

export const NotAvailable = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  z-index: 1;
  right: 10px;
  top: 10px;
  padding: 0 8px;
  height: 30px;
  border: 1px solid rgba(0,0,0,0.08);
  border-radius: 4px;
  background-color: #FFFFFF;
  box-shadow: 0 1px 3px 0 rgba(0,0,0,0.08), 0 2px 6px 0 rgba(0,0,0,0.08);
  font-size: 14px;

  [class*=" cl-"] {
    margin-right: 8px;
    font-size: 14px;
  }
`;
